"use client";
import styles from "./get-free-access-page.module.scss";
import ServicePageHeader from "@/components/common/service-page-header";
import Link from "next/link";
import Image from "next/image";
import posterImage from "@/assets/social-media/audiomodify-poster.webp";
import posterImageToDownload from "@/assets/social-media/audiomodify-poster.png";
import FilledButton from "@/components/common/filled-button";
import { useDownload } from "@/hooks/use-download";
import { useState } from "react";
import Loader from "@/components/common/loader";

const GetFreeAccessPage = () => {
  const [isLoading, setIsLoading] = useState(false);
  const { downloadLocal, download } = useDownload();

  const handleDownload = async () => {
    setIsLoading(true);
    const response = await fetch(posterImageToDownload.src);
    const blob = await response.blob();
    const blobUrl = URL.createObjectURL(blob);
    await downloadLocal(blobUrl, "AudioModify.png");
    setIsLoading(false);
    URL.revokeObjectURL(blobUrl);
  };

  const handleDownloadVideo = async () => {
    setIsLoading(true);
    await download(
      "https://songwiz.nyc3.digitaloceanspaces.com/static/get-free-access/How%20to%20use%20AudioModify.mp4",
      "AudioModify.mp4",
    );
    setIsLoading(false);
  };

  return (
    <div className={styles.page_wrapper}>
      <ServicePageHeader
        title={
          <>
            Get <span>Free</span> Access
          </>
        }
        description={"Get FREE Access to AudioModify with 4 easy steps:"}
      />
      <div className={styles.steps}>
        <div>1. Make post/story/video about AudioModify</div>
        <div>
          2. Share it on your social media with clickable link to
          https://audiomodify.com
        </div>
        <div>
          3. Send the link to the posted post to{" "}
          <Link href={"mailto: hi@audiomodify.com"}>hi@audiomodify.com</Link>
        </div>
        <div>4. Enjoy FREE access to AudioModify ;)</div>
      </div>
      <Image
        className={styles.image}
        src={posterImage}
        alt={"Poster"}
        width={600}
        height={340}
      />
      <div className={styles.download_button_wrapper}>
        {isLoading ? (
          <Loader size={"50px"} />
        ) : (
          <div className={styles.buttons_wrapper}>
            <FilledButton
              text={"Download Image"}
              padding={"12px 16px"}
              onClick={handleDownload}
            />
            {/*<FilledButton*/}
            {/*  text={"Download Video"}*/}
            {/*  padding={"12px 16px"}*/}
            {/*  onClick={handleDownloadVideo}*/}
            {/*/>*/}
          </div>
        )}
      </div>
    </div>
  );
};

export default GetFreeAccessPage;
